import { SimpleChanges } from '@angular/core';
import { MAX_POINTS_PER_SERIES } from 'ChartApp/ts/features/scatter-plot/constants/scatter-plot-highcharts-plot-options.constants';
import { ScatterPlotPlotOptionValue, ScatterPlotPlotType, ScatterPlotSeriesType, ScatterPlotStatus, } from 'ChartApp/ts/enums/scatter-plot-common.enum';
import { getFormatter } from 'Angular/utils/number_formatter';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
const _c0 = a0 => ({ "left": a0 });
const _c1 = () => ({ "large": "size-lg", "medium": "size-md", "small": "size-sm" });
const _c2 = a0 => ({ "color": a0 });
function ScatterPlotLegendComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "div", 5)(2, "div", 6)(3, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r0.xAxis);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r0.yAxis);
} }
function ScatterPlotLegendComponent_div_0_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const series_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction0(3, _c1)[series_r2.size])("ngStyle", i0.ɵɵpureFunction1(4, _c2, series_r2.color));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-shape-" + series_r2.shape);
} }
function ScatterPlotLegendComponent_div_0_div_2_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const series_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" - ", series_r2.parentSecurityListName);
} }
function ScatterPlotLegendComponent_div_0_div_2_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 9);
} if (rf & 2) {
    const series_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("textContent", " (" + series_r2.currencyCode + ")");
} }
function ScatterPlotLegendComponent_div_0_div_2_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 15);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const series_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", series_r2.numItems === 1 ? " " + series_r2.numItems + " item" : " " + series_r2.numItems + " items");
} }
function ScatterPlotLegendComponent_div_0_div_2_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 15);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("textContent", " (exceeds max of " + ctx_r0.MAX_POINTS_PER_SERIES + " points)");
} }
function ScatterPlotLegendComponent_div_0_div_2_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 16)(2, "div", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const series_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", series_r2.x || "--");
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", series_r2.y || "--");
} }
function ScatterPlotLegendComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "span", 7);
    i0.ɵɵtemplate(3, ScatterPlotLegendComponent_div_0_div_2_span_3_Template, 2, 6, "span", 8);
    i0.ɵɵelement(4, "span", 9);
    i0.ɵɵtemplate(5, ScatterPlotLegendComponent_div_0_div_2_span_5_Template, 2, 1, "span", 10)(6, ScatterPlotLegendComponent_div_0_div_2_span_6_Template, 1, 1, "span", 11)(7, ScatterPlotLegendComponent_div_0_div_2_ng_container_7_Template, 2, 1, "ng-container", 10)(8, ScatterPlotLegendComponent_div_0_div_2_span_8_Template, 1, 1, "span", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, ScatterPlotLegendComponent_div_0_div_2_ng_container_9_Template, 3, 2, "ng-container", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const series_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", series_r2.type === ctx_r0.scatterPlotSeriesType.security || series_r2.type === ctx_r0.scatterPlotSeriesType.efficientFrontier || series_r2.numItems);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", series_r2.displayLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", series_r2.parentSecurityListName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.displayCurrencyCode && series_r2.type === ctx_r0.scatterPlotSeriesType.security && series_r2.currencyCode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", series_r2.numItems !== undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", series_r2.numItems && series_r2.numItems > ctx_r0.MAX_POINTS_PER_SERIES || (series_r2 == null ? null : series_r2.errors == null ? null : series_r2.errors.includes("data_size_exceeds_limit")));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.displayXYData);
} }
function ScatterPlotLegendComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, ScatterPlotLegendComponent_div_0_div_1_Template, 4, 2, "div", 2)(2, ScatterPlotLegendComponent_div_0_div_2_Template, 10, 7, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("chart-legend " + ctx_r0.widthClass);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(5, _c0, ctx_r0.legendLeftPx));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.displayXYData);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.scatterPlotLegendData);
} }
/**
 * ScatterPlotLegendComponent
 *
 * Inputs:
 * scatterPlotInfo: The response returned from the backend ScatterPlotDataView.
 * status: The status of the scatterPlotInfo being fetched.
 * plotOptions: Legend option per serie
 * widthClass: css class to set legends width
 */
export class ScatterPlotLegendComponent {
    constructor() {
        this.widthClass = 'col-lg-8';
        // Legend options
        this.displayLegend = false;
        this.displayXYData = true;
        this.displayCurrencyCode = false;
        this.nameInLegend = '';
        this.xAxis = '';
        this.yAxis = '';
        // Component State
        this.isAlive = true;
        this.legendLeftPx = '72px';
        // Constants
        this.MAX_POINTS_PER_SERIES = MAX_POINTS_PER_SERIES;
        this.scatterPlotSeriesType = ScatterPlotSeriesType;
    }
    ngOnInit() {
        this.updateLegendPosition();
    }
    ngOnChanges(changes) {
        if (changes?.status) {
            this.handleStatus(changes.status.currentValue);
        }
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    /**
     * Configure the legend depending on the status of scatterPlotInfo
     * @param status
     */
    handleStatus(status) {
        if (status === ScatterPlotStatus.ok && this.scatterPlotInfo && this.scatterPlotInfo.data.series.length) {
            // Display the legend if the global "Show Legend" is checked and "Include In Legend" is checked for
            // at least one security.
            this.displayLegend = this.scatterPlotInfo.params.displayLegend;
            const atLeastOneSecurityIncludedInLegend = this.scatterPlotInfo.data.series.some((s) => s[ScatterPlotPlotOptionValue.includeInLegend]);
            this.displayLegend = this.displayLegend && atLeastOneSecurityIncludedInLegend;
            // Set legend options
            const options = this.getLegendOptions(this.scatterPlotInfo);
            this.displayCurrencyCode = options.displayCurrencyCode;
            this.displayXYData = options.displayXYData;
            // Get data to display in legend
            this.scatterPlotLegendData = this.createScatterPlotLegendData(this.scatterPlotInfo);
        }
        else {
            this.displayLegend = false;
        }
    }
    /**
     * Process backend data to get info to display in the legend.
     * @param scatterPlotInfo - The scatter plot info returned from the backend.
     * @returns A list of processed legend data.
     * @private
     */
    createScatterPlotLegendData(scatterPlotInfo) {
        const scatterPlotLegendData = [];
        const xFormatter = getFormatter(scatterPlotInfo.data.x_axis_type);
        const yFormatter = getFormatter(scatterPlotInfo.data.y_axis_type);
        this.xAxis = scatterPlotInfo.data.x_axis_short_label;
        this.yAxis = scatterPlotInfo.data.y_axis_short_label;
        for (let i = 0; i < scatterPlotInfo.data.series.length; i += 1) {
            const series = scatterPlotInfo.data.series[i];
            const data = series.data[0];
            const plotOptionsId = `${series.type}__${series.id}`;
            // eslint-disable-next-line no-continue
            if (!this.plotOptions[plotOptionsId][ScatterPlotPlotOptionValue.includeInLegend])
                continue;
            const displayLabel = series.name;
            // Common legend data
            let legendData = {
                color: series.color,
                currencyCode: data?.currency_code ?? '',
                displayLabel,
                parentSecurityListName: series.parent_security_list_name,
                shape: series.shape,
                size: series.size,
                type: series.type,
                errors: series.errors ?? [],
            };
            // Security data
            if (series.type === ScatterPlotSeriesType.security ||
                series.type === ScatterPlotSeriesType.efficientFrontier) {
                legendData = {
                    ...legendData,
                    displayLabel,
                    x: data?.x && series.type === ScatterPlotSeriesType.security ? xFormatter(data.x) : '',
                    y: data?.y && series.type === ScatterPlotSeriesType.security ? yFormatter(data.y) : '',
                };
            }
            // Security list data
            else {
                // If there are no errors, filter any points that are not visible on the chart (likely because of null values)
                const numItems = series.errors?.length
                    ? undefined
                    : series.data.filter((point) => (point.x || point.x === 0) && (point.y || point.y === 0)).length;
                legendData = {
                    ...legendData,
                    numItems,
                };
            }
            scatterPlotLegendData.push(legendData);
        }
        return scatterPlotLegendData;
    }
    /**
     * Get options configuring what to display in the legend.
     * @param scatterPlotInfo - The scatter plot info returned from the backend.
     * @returns An object containing scatter plot legend options
     * @private
     */
    getLegendOptions(scatterPlotInfo) {
        const { display_currency_code_in_legend, display_x_y_data_in_legend, name_in_legend, series, plot_type } = scatterPlotInfo.data;
        const onlySecurityLists = series
            .filter((s) => s[ScatterPlotPlotOptionValue.includeInLegend])
            .every((s) => s.type === ScatterPlotSeriesType.securityList);
        return {
            displayCurrencyCode: display_currency_code_in_legend,
            displayXYData: display_x_y_data_in_legend && plot_type === ScatterPlotPlotType.pointInTime && !onlySecurityLists,
            nameInLegend: name_in_legend,
        };
    }
    updateLegendPosition() {
        this.legendLeftPx = window.innerWidth <= 1024 ? '0px' : '72px';
    }
}
ScatterPlotLegendComponent.ɵfac = function ScatterPlotLegendComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotLegendComponent)(); };
ScatterPlotLegendComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScatterPlotLegendComponent, selectors: [["ycn-scatter-plot-legend"]], hostBindings: function ScatterPlotLegendComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function ScatterPlotLegendComponent_resize_HostBindingHandler($event) { return ctx.updateLegendPosition($event); }, i0.ɵɵresolveWindow);
    } }, inputs: { scatterPlotInfo: "scatterPlotInfo", status: "status", plotOptions: "plotOptions", widthClass: "widthClass" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["style", "pointer-events: none", 3, "class", "ngStyle", 4, "ngIf"], [2, "pointer-events", "none", 3, "ngStyle"], ["class", "chart-legend-item", 4, "ngIf"], ["class", "chart-legend-item", 4, "ngFor", "ngForOf"], [1, "chart-legend-item"], [1, "chart-legend-item-name"], [1, "chart-legend-item-value", "line-clamp-2", 3, "textContent"], [1, "chart-legend-item-title", "custom-bullet"], ["class", "shape-select-choice text-1", 3, "ngClass", "ngStyle", 4, "ngIf"], [3, "textContent"], [4, "ngIf"], [3, "textContent", 4, "ngIf"], ["class", "text-gray-50", 3, "textContent", 4, "ngIf"], [1, "shape-select-choice", "text-1", 3, "ngClass", "ngStyle"], ["ycnIcon", "", 3, "name"], [1, "text-gray-50", 3, "textContent"], [1, "chart-legend-item-value", 3, "textContent"]], template: function ScatterPlotLegendComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ScatterPlotLegendComponent_div_0_Template, 3, 7, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.displayLegend);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgStyle, i2.IconDirective], encapsulation: 2 });
